import type {LocalesInfo, SiteLocale} from '@wix/ambassador-dm-document-models-v1-models/types'
import type {CreateExtArgs, Extension, ExtensionAPI} from '@wix/document-manager-core'

const createExtension = (): Extension => {
    const createExtensionAPI = ({dal, pointers}: CreateExtArgs): LocalesExtensionAPI => {
        const getLocalesInfo = (): LocalesInfo | null | undefined => dal.get(pointers.rendererModel.getLocalesInfo())

        return {
            locales: {
                list: () => getLocalesInfo()?.locales ?? [],
                isMultilingualEnabled: () => !!getLocalesInfo()?.multilingualEnabled
            }
        }
    }

    return {
        name: 'locales',
        dependencies: new Set(['rendererModel']),
        createExtensionAPI
    }
}

export interface LocalesAPI extends ExtensionAPI {
    list(): SiteLocale[]
    isMultilingualEnabled(): boolean
}

export interface LocalesExtensionAPI extends ExtensionAPI {
    locales: LocalesAPI
}

export {createExtension}
